module.exports = __webpack_public_path__ + "static/media/cotripper.005e9f32.jpg";